<template>
  <span class="flex">
    <span v-if="days" class="mr-1">{{ days }} {{ $t('common.days') }}</span>
    <span v-if="hours">{{ hours.toString().padStart(2, '0') }}:</span>
    {{ minutes.toString().padStart(2, '0') }}:{{
      Math.floor(seconds).toString().padStart(2, '0')
    }}
  </span>
</template>

<script setup lang="ts">
  import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';

  const props = defineProps<{ date: number }>();
  const now = ref(Math.floor(Date.now() / 1000));
  let interval: number | undefined;

  const diff = computed(() => Math.max(props.date - now.value, 0));
  const days = computed(() => Math.floor(diff.value / 86400));
  const hours = computed(() => Math.floor((diff.value % 86400) / 3600));
  const minutes = computed(() => Math.floor((diff.value % 3600) / 60));
  const seconds = computed(() => diff.value % 60);

  onMounted(() => {
    interval = window.setInterval(() => {
      now.value = Math.floor(Date.now() / 1000);
    }, 1000);
  });
  onBeforeUnmount(() => {
    if (interval) clearInterval(interval);
  });

  watch(
    () => props.date,
    () => {
      now.value = Math.floor(Date.now() / 1000);
    }
  );
</script>
